var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussiaGosloto5From36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 66.735,
    cy: 6.174,
    r: 22.075,
    gradientTransform: "matrix(1 0 0 2.0244 0 -6.324)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#d0e5c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#7fe057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#7fe057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#7ddc55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#76ce50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#6ab847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#66b144"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 59.756,
    cy: 31.641,
    r: 28.83,
    gradientTransform: "matrix(.7832 -.6217 .3483 .4387 1.934 54.912)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 63.806,
    cy: 16.807,
    r: 19.972,
    gradientTransform: "matrix(1 0 0 .6011 0 6.704)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#d0e5c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#cbe5b9",
    stopOpacity: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#bde4a7",
    stopOpacity: 0.612
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#a5e289",
    stopOpacity: 0.345
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#85e05f",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#7fe057",
    stopOpacity: 0
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 62.668,
    cy: 48.356,
    r: 10.553,
    gradientTransform: "matrix(1 0 0 .4975 0 24.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2f22"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 84.913,
    cy: 24.369,
    r: 12.57,
    gradientTransform: "matrix(.6542 .7563 -.5753 .4976 43.382 -51.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 68.357,
    cy: 8.624,
    r: 6.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 65.436,
    cy: 28.331,
    r: 22.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d0e5c0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#a6e28a",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe057"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 15.692,
    cy: 26.941,
    r: 35.519,
    gradientTransform: "matrix(.9164 .4003 -.3263 .7469 10.102 .538)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#d0e5c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#7fe057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#7fe057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#7ddc55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#76ce50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#6ab847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#66b144"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 31.191,
    cy: 24.67,
    r: 29.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 19.218,
    cy: 11.332,
    r: 7.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#04050e",
    stopOpacity: 0.908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#0e0c12",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#211a18",
    stopOpacity: 0.746
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#3a2c21",
    stopOpacity: 0.669
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 31.545,
    cy: 52.415,
    r: 6.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2f22"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 25.785,
    cy: 31.335,
    r: 24.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d0e5c0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#a6e28a",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe057"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 46.163,
    cy: 26.157,
    r: 7.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 4.862,
    cy: 38.414,
    r: 6.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 19.001,
    cy: 18.195,
    r: 21.15,
    gradientTransform: "matrix(.9521 -.3059 .2208 .6873 -3.107 11.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#d0e5c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#cbe5b9",
    stopOpacity: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#bde4a7",
    stopOpacity: 0.612
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#a5e289",
    stopOpacity: 0.345
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#85e05f",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#7fe057",
    stopOpacity: 0
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 88.026,
    cy: 9.457,
    r: 9.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffc4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#fffc4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0bb4f"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 91.579,
    cy: 10.13,
    r: 4.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 85.598,
    cy: 11.336,
    r: 3.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.179 49.691c0 11.947-9.683 21.63-21.64 21.63-11.947 0-21.63-9.683-21.63-21.63s9.683-21.64 21.63-21.64a21.65 21.65 0 0 1 21.64 21.64z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.62 35.304c1.568-.529 4.342-1.294 7.252-.97 4.449.5 8.282 1.431 10.506 2.597 2.225 1.176 3.773 2.107 4.44 4.969s-.108 9.889-1 13.162c-.882 3.283-1.47 5.773-3.852 7.086s-6.449 2.117-11.927 1.068-9.271-3.734-10.32-5.145-1.95-2.676-1.029-8.644c.686-4.469 1.058-8.174 2.617-11.036.51-.931 1.539-2.489 3.313-3.087z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m56.66 44.477 3.273-.137s.627-2.284 2.058-1.725c1.431.549.804 2.872-.333 3.371-1.137.51-2.019.559-2.019.559l-.206 2.823s1.97-.206 2.019 1.862c.039 2.068-1.686 3.166-2.313 1.862s-.461-2.44-.461-2.44l-3.146.039s-.255 7.135 3.94 7.096c4.195-.049 4.959-3.852 4.832-6.459-.137-2.617-1.509-3.626-1.509-3.626s2.47-1.186 2.509-4.185c.02-.96-.167-2.362-1.176-3.146-2.137-1.666-6.184-1.568-7.468 4.106zm15.152-3.342s-5.586 5.41-5.831 11.016c-.255 5.616 2.019 7.478 4.949 6.762 2.94-.715 4.244-3.93 3.989-7.723-.245-3.803-3.989-4.185-3.989-4.185s.049-.549 1.264-1.98c1.205-1.441 1.882-1.823 1.882-1.823l-2.264-2.068zm-1.166 8.556s-1.686.108-1.774 2.881c-.088 2.783 1.754 3.469 2.627 1.558.882-1.911.363-4.518-.853-4.44z",
    style: {
      fill: "#fffc4f",
      fillRule: "evenodd"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.325 47.908s2.705-1.47 6.272-1.901 5.704 0 5.704 0 10.163-6.939.882-9.977c-8.958-2.93-16.475-2.333-18.562-.294-2.088 2.048-2.284 6.008-2.039 6.89s1.372-1.803 7.556 5.283",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.539 67.107c-2.774-.382-5.969-1.186-7.35-1.568s-2.333.049-2.901.715c-.323.382-.343 1.45-.294 2.323a21.532 21.532 0 0 0 10.545 2.754c1.813 0 3.567-.245 5.243-.666.657-.774 1.117-1.539 1.039-2.127-.176-1.519-3.509-1.049-6.282-1.431z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.548 71.096c-.372-.902-1.274-1.754-3.009-2.235l-.01 2.225a2.78 2.78 0 0 0 .461.206 20.15 20.15 0 0 0 2.558-.196zm-9.095-.657a.706.706 0 0 1 .235-.157c.892-.382 1.656-.235 1.656-.235l.078-2.137s-3.675-.304-4.646 1.549c.853.382 1.754.706 2.676.98zm2.666.588a22.05 22.05 0 0 0 1.99.225l-.049-.431-1.892-.225s.01.196-.049.431z",
    style: {
      fill: "#fffc4f",
      fillRule: "evenodd"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m84.229 56.081 1.098-3.42h.617l.147-1.47-.676.039-.049-2.009.774-.078a21.533 21.533 0 0 0-.764-5.175c-.617.059-1.294.265-1.441.941-.284 1.284-.049 5.753-.764 8.605s-1.696 6.165-.902 6.753c.245.176.588.255.941.294l.911-1.745a4.989 4.989 0 0 1 .108-2.734z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.539 28.061a21.797 21.797 0 0 0-4.959.578c.127.99.706 2.421 2.97 2.48 3.46.088 6.253.323 8.282.921 2.029.588 3.832 1.715 5.116.461.235-.235.353-.549.431-.892a21.443 21.443 0 0 0-11.839-3.548z",
    fill: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.45 28.277c-.676.098-1.49.059-2.205-.186l-.706-.029c-1.029 0-2.039.088-3.038.225.902 1.696 3.381 2.372 6.272 2.078 1.47-.147 2.284-.804 2.744-1.46a21.003 21.003 0 0 0-3.068-.627z",
    style: {
      fill: "#fffc4f",
      fillRule: "evenodd"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.539 28.061c-9.712 0-17.925 6.39-20.66 15.201 1.637-1.696 3.822-3.832 5.802-5.332 3.754-2.852 6.419-7.556 13.211-7.703s11.026.049 15.593 4.753c3.469 3.577 6.4 7.517 7.596 12.76-.99-11.036-10.251-19.68-21.542-19.68z",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.211 53.082c0 13.231-10.722 23.953-23.953 23.953S2.305 66.313 2.305 53.082 13.027 29.13 26.258 29.13s23.953 10.722 23.953 23.953z",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.812 44.301c1.333-1.264 3.754-3.322 6.841-4.351 4.704-1.568 8.987-2.421 11.761-2.284 2.783.147 4.773.353 6.772 2.921s4.489 9.977 5.136 13.692c.637 3.705 1.215 6.488-.568 8.909s-5.488 5.136-11.477 6.625c-5.988 1.499-11.045.568-12.76-.353-1.715-.931-3.205-1.784-5.057-8.203-1.392-4.812-2.744-8.703-2.519-12.3.069-1.186.372-3.234 1.872-4.655z",
    fill: "url(#i)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.134 36.264c3.028-1.235 4.891-1.705 7.811-2.323 2.921-.608 4.489-.931 4.793-1.999.157-.539-.118-1.705-.421-2.725l-2.058-.108c-5.861 0-11.222 2.117-15.387 5.606l.157 1.539c.147 1.549 2.078 1.245 5.106.01z",
    fill: "url(#j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.07 72.752c-3.734.97-8.801 1.392-9.134 2.558-.127.451.137 1.019.519 1.549.921.108 1.852.176 2.803.176 5.528 0 10.604-1.892 14.662-5.038-.265-.804-.559-1.499-.862-1.813-1.058-1.078-4.263 1.598-7.988 2.568z",
    fill: "url(#k)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.383 75.389c-2.107.686-5.557 1.029-5.557 1.029v.529a23.71 23.71 0 0 0 10.477-3.195l-.657-.608s-2.156 1.558-4.263 2.244zm-10.8-45.955a23.737 23.737 0 0 0-8.546 3.068c3.136 1.117 6.606-.353 8.546-3.068z",
    style: {
      fill: "#fffc4f"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.873 44.938c1.617-3.901 6.655-9.644 15.211-12.359 8.556-2.705 15.495 1.754 15.495 1.754s3.185-.147 6.037 1.519c1.617.941 4.41 4.538 6.527 7.488-3.744-8.37-12.123-14.211-21.885-14.211-13.231 0-23.953 10.722-23.953 23.953 0 1.852.235 3.646.627 5.381-.274-5.557.804-10.781 1.941-13.525z",
    fill: "url(#l)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.331 39.685c-.284.97.147 3.156 1.029 4.753.882 1.607 2.097 5.675 2.342 7.919s.637 4.636 2.44 4.498c.745-.059 1.421-.902 1.98-1.872l.098-1.882a23.78 23.78 0 0 0-4.891-14.456c-1.019.088-2.803.353-2.999 1.039z",
    fill: "url(#m)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.048 68.616c.402-.098.735-.225.882-.461.745-1.235-.167-2.509-1.539-5.743s-1.607-5.155-1.99-7.37-1.058-4.028-2.048-4.126c-.265-.029-.588.049-.931.186l-.098 1.999c-.01 5.92 2.156 11.33 5.724 15.514z",
    fill: "url(#n)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m3.697 57.15-1.323-3.087-.02.01a25.37 25.37 0 0 0 .363 3.362l.98-.284zm-.372 2.823a23.786 23.786 0 0 0 3.009 6.4c.372-.735.559-1.549.48-2.401-.157-1.803-1.45-3.42-3.489-3.999zm46.769-9.203a10.208 10.208 0 0 1-2.137-.598l.049 2.852a6.107 6.107 0 0 0 2.176.794l.039-.735-.127-2.313zm-3.028-3.401 2.382-.167a24.026 24.026 0 0 0-3.126-7.194l-.519.137 1.264 7.223zM19.193 56.68l-.627-11.986 9.438-3.048 1.686 4.812-6.713 2.362.039 2.754c6.106-3.068 10.32.882 10.663 5.528.49 6.596-7.027 11.633-12.3 7.674l-.059-4.449c9.448 4.577 8.977-6.713 4.753-6.419-2.774.196-2.852 1.803-2.852 1.803l-4.028.97z",
    style: {
      fill: "#fffc4f"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.725 49.358s-.617-5.557 1.568-7.988c2.186-2.421 6.606-4.087 10.977-4.851s8.987.235 9.791 1.754.5 7.978-2.372 9.32c-3.254 1.519-8.987 4.518-13.113 5.087-4.146.578-6.233.96-6.851-3.322z",
    fill: "url(#o)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.041 22.965c5.332 0 9.654 4.351 9.654 9.712s-4.322 9.712-9.654 9.712-9.654-4.351-9.654-9.712 4.322-9.712 9.654-9.712z",
    fill: "url(#p)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.835 37.509h5.88v-1.264h-1.588v-9.673l-2.313.02s-.127.617-.666 1.696c-.539 1.068-1.382 1.99-1.382 1.99l1.696-.01s.245-.245.5-.706v6.684h-2.127v1.264z",
    fill: "url(#q)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.816 33.863h-2.303v2.313h-1.264v-2.313h-2.303v-1.274h2.303v-2.323h1.264v2.323h2.303z",
    fill: "url(#r)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussiaGosloto5From36);
export default __webpack_public_path__ + "static/media/russia_gosloto_5_from_36.592f7fa1e57d66b6ef3c9ce91e312dae.svg";
export { ForwardRef as ReactComponent };